import { string } from 'prop-types'
import { useEffect } from 'react'

import expander from 'views/assets/scripts/expander'
import floatingLabel from 'views/assets/scripts/floatingLabel'
import { MarketPlaceDiscountModalContent } from 'views/components/organisms/MarketPlaceDiscountModal/MarketPlaceDiscountModalContent'

const MarketPlaceDiscountModalContainer = ({
  discountConditionValue,
  discountValue,
  discountType,
}) => {
  useEffect(() => {
    expander()
    floatingLabel()
  }, [])

  return (
    <MarketPlaceDiscountModalContent
      discountConditionValue={discountConditionValue}
      discountValue={discountValue}
      discountType={discountType}
    />
  )
}

MarketPlaceDiscountModalContainer.propTypes = {
  discountConditionValue: string,
  discountValue: string,
  discountType: string,
}

export default MarketPlaceDiscountModalContainer
